import { UNPROTECTED_ROUTES } from "../routes/routes";
import { removeAuthentication } from "../configs/userSlice";
import { freeCache } from "../configs/cache";
import { toast } from "sonner";

const userLogout = (
  navigate,
  dispatch,
  showToast = false,
  toastMessage = "You are logged on another device. Please try to login again",
  redirect = true
) => {
  // alert("bkp");
  dispatch(removeAuthentication());
  dispatch(freeCache());
  if (showToast) {
    toast(toastMessage);
  }
  sessionStorage.removeItem("authenticated");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userDetail");
  sessionStorage.removeItem("userProfilePic");
  sessionStorage.clear();
  if (redirect && navigate) {
    navigate(UNPROTECTED_ROUTES?.home);
  }
};

export default userLogout;
